import * as React from "react";
import Header from "components/layout/Header/PageHeader/Header";
import { Event } from "common/event/event.types";
import { generateUrl } from "utils/generateUrl";
import { ROUTES } from "common/routes";
import { NavBar } from "@access-selfcare/shared-libs";
import { useLocation, useNavigate } from "react-router";
import { compact } from "lodash";

type Props = {
  event: Event;
  showInvestorProfiles: boolean;
  showFeedbacks: boolean;
};

export const EventNavigation: React.FC<Props> = ({ showInvestorProfiles, showFeedbacks, event }) => {
  const navigateTo = useNavigate();
  const { pathname } = useLocation();

  const navItems = compact([
    {
      label: "Roadshow",
      returnedValue: generateUrl(ROUTES.EVENT_DETAIL_CORPORATE, event.id),
      isActive: pathname.includes(generateUrl(ROUTES.EVENT_DETAIL_CORPORATE, event.id)),
    },
    {
      label: "Contacts",
      returnedValue: generateUrl(ROUTES.EVENT_DETAIL_CONTACT, event.id),
      isActive: pathname.includes(generateUrl(ROUTES.EVENT_DETAIL_CONTACT, event.id)),
    },
    {
      label: "Invitation status",
      returnedValue: generateUrl(ROUTES.EVENT_DETAIL_INVITATION_STATUS, event.id),
      isActive: pathname.includes(generateUrl(ROUTES.EVENT_DETAIL_INVITATION_STATUS, event.id)),
    },
    showInvestorProfiles && {
      label: "Investor profiles",
      returnedValue: generateUrl(ROUTES.EVENT_INVESTOR_PROFILE, event.id),
      isActive: pathname.includes(generateUrl(ROUTES.EVENT_INVESTOR_PROFILE, event.id)),
    },
    showFeedbacks && {
      label: "Feedbacks",
      returnedValue: generateUrl(ROUTES.EVENT_FEEDBACK, event.id),
      isActive: pathname.includes(generateUrl(ROUTES.EVENT_FEEDBACK, event.id)),
    },
  ]);

  const eventNavBar: React.ReactElement = (
    <NavBar navItems={navItems} handleOnClick={(route) => route && navigateTo(route)} className="mt-3" />
  );

  return <Header mainTitle={event.name} headerOptions={{ navBar: eventNavBar, event }} />;
};
